import { xmlDecl, el } from './index.js';
import { NS } from '../ns.js';

export function generateContainerXml(): string {
  return (
    xmlDecl() +
    '\n' +
    el(
      'container',
      { xmlns: NS.odf, version: '1.0' },
      '\n' +
      el(
        'rootfiles',
        {},
        '\n' +
        el('rootfile', {
          'full-path': 'Contents/content.hpf',
          'media-type': NS.mimeHwpx,
        }) +
        '\n',
      ) +
      '\n',
    )
  );
}
